import Vue from 'vue'

import DirectusSDK from "@directus/sdk-js"

const client = new DirectusSDK({
  url: process.env.VUE_APP_DIRECTUS_URL,
  project: process.env.VUE_APP_DIRECTUS_PROJECT,
  storage: window.localStorage,
  persist: true
})

Vue.prototype.$directus = Vue.prototype.$directus || client
export default Vue.prototype.$directus
